module.exports = __webpack_public_path__ + "static/media/kolorowanka_1.edecfd32.png";